import React from "react";

const PlanCard = ({ name, price, features, gold }) => {
  return (
    <div className="col-md-4 mb-4">
      <div className="subPlans wow animate__animated animate__fadeInUp">

        <div className={`planName ${gold ? "gold" : ""}`}>
          {name}
        </div>

        <div className="planPrice">
          Rs. {price}
        </div>

        <div className="planDetail">
          <ul>
            {features.map((item, index) => (
              <li key={index}>
                <p>{item}</p>
              </li>
            ))}
          </ul>
        </div>

      </div>
    </div>
  );
};

export default React.memo(PlanCard);